export default __webpack_public_path__ + "static/media/old-partner.770ad31f.svg";